import * as React from 'react';
import {TscButtonType, PopoverButton, TscPopoverOrigin, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import GroupsMenuContainer from '../GroupsMenu/GroupsMenuContainer';
import Themeable from '../../types/Themeable';
import Strings from '../../globals/Strings';

export default ({disabled, addEmails, themeName}: SelectGroupsButtonProps) => {
   const groupsButton = <div className="groups-button">
                           <Glyphs.Groups16x16/>
                           <Glyphs.CaratDown16x16/>
                        </div>;

   return <PopoverButton buttonGlyph={groupsButton}
                     buttonType={TscButtonType.tertiary}
                     buttonTitle={Strings.labels.groups}
                     disabled={disabled}
                     origin={TscPopoverOrigin.bottomLeft}
                     popoverMenu={<GroupsMenuContainer addEmails={addEmails}/>}
                     themeName={themeName}
                     showArrow={false}
                     closeMenuOnClick={true}
                     testId="groups"/>;
};

export interface SelectGroupsButtonProps extends Themeable {
   disabled: boolean;
   addEmails(emails: string[]): void;
}
